"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterNullish = void 0;
exports.combineWithInput = combineWithInput;
exports.toObservable = toObservable;
const rxjs_1 = require("rxjs");
/**
 * Util method which combines the input with the output
 * Especially useful when you need to combine observables
 * e.g. switchMap(input => observableFn(input).pipe(map(combineWithInput(input)))
 * passes back: [input, output]
 * @param input
 * @returns a function returning a typed array of [input, output]
 */
function combineWithInput(input) {
    return (output) => [input, output];
}
function toObservable(item) {
    if (item instanceof rxjs_1.Observable) {
        return item;
    }
    return (0, rxjs_1.from)(Promise.resolve(item));
}
const filterNullish = () => (0, rxjs_1.pipe)((0, rxjs_1.filter)(x => x !== undefined && x !== null));
exports.filterNullish = filterNullish;
